  import { Component, OnDestroy, OnInit } from "@angular/core";
  import { AlwaysProtectedCheckService } from "../services/always-protected-check.service";
  import { getOverviewProductType } from "../overview/util/overview-util";
  import { Router } from "@angular/router";
  import { NortonProductCheckService} from "../services/norton-product-check.service";
  import { savePiiNsp } from "../shared/pii/pii.utils";
  import { TranslationService } from "@proximus/ng-common";
  import { AlwaysProtectedOptions } from "./always-protected";
  import { Product } from "@dch/products-business-logic";
  import {Subscription} from "rxjs";
import { NORTON_PRODUCT, NORTON_SEC_5 } from "../always-protected-check.constants";

  @Component({
    selector: 'mprd-always-protected',
    templateUrl: './always-protected.component.html',
    styleUrls: ['./always-protected.component.css']
  })
  export class AlwaysProtectedComponent implements OnInit, OnDestroy {
    private alwaysProtectedResSubscription: Subscription;
    private easyProtectPackIdValueResSubscription: Subscription;
    easyProtectOptions: (AlwaysProtectedOptions | Product)[] = [];
    productType: string;
    easyProtectPackIdVal = '';
    constructor(
      private alwaysProtectedService: AlwaysProtectedCheckService,
      private router: Router,
      private nortonProductCheck: NortonProductCheckService,
      private translationService: TranslationService,
    ) { }

    ngOnInit(): void {

      this.alwaysProtectedResSubscription = this.alwaysProtectedService.alwaysProtectedRes?.subscribe((data) => {
        this.easyProtectOptions = data;
      });
      this.easyProtectPackIdValueResSubscription = this.alwaysProtectedService.easyProtectPackIdValueRes?.subscribe(data => {
        this.easyProtectPackIdVal = data;
      });
    }

    private hasDescription(option: AlwaysProtectedOptions | Product): option is AlwaysProtectedOptions
    {
      return (option as AlwaysProtectedOptions).description !== undefined;
    }
    public openAlwaysProtected(innerText: string) {
      const product = this.easyProtectOptions.find(
        (e) => (this.hasDescription(e) && e.description === innerText) || e.productDescription === innerText
      );
      let payload = {};
      if (product) {
        this.productType = getOverviewProductType(product.plc, product.labelIdentifier);
        if (innerText === NORTON_SEC_5 && this.productType === NORTON_PRODUCT) {
          this.handleNortonRedirection(product.groupMpcUuid,innerText);
        } else {
          payload = {
            packId: this.easyProtectPackIdVal,
          };
          savePiiNsp(payload);
          this.router.navigate(['/nspManage']);
        }
      }
    }

    handleNortonRedirection = (nortonGroupId: string,nortonProdName: string) => {
      const newNortonDetailPageMpcuuids = ['PMBDV', 'CPZJA'];
      if (newNortonDetailPageMpcuuids.includes(nortonGroupId)) {
        this.router.navigate(['/norton360']);
      } else {
        this.nortonProductCheck.checkForNortonName(nortonProdName);
        this.router.navigate(['/' + this.productType.toLowerCase()]);
      }
    };

    ngOnDestroy() {
      this.alwaysProtectedResSubscription?.unsubscribe();
      this.easyProtectPackIdValueResSubscription?.unsubscribe();
    }
  }
